module.exports = __webpack_public_path__ + "static/media/BeautyandtheBesharamJacket.a1f2b2ef.jpg";